import { Component, Injector, OnDestroy, OnInit } from "@angular/core";
import { BreadcrumbService } from "../../../shared/services/breadcrumb.service";
import { BaseComponent } from "../base.component";

@Component({
  selector: "app-breadcrumbs",
  templateUrl: "./breadcrumbs.component.html",
  styleUrls: ["./breadcrumbs.component.scss"],
})
export class BreadcrumbsComponent extends BaseComponent implements OnInit, OnDestroy {
  breadcrumbList: Array<any> = [];

  constructor(
      private injector: Injector,
      breadcrumbService: BreadcrumbService
    ) {
    super(injector);
    this.breadcrumbList = this.breadcrumbService.getBreadcrumbs();
  }
  

  ngOnInit() {
    super.ngOnInit();
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

}
